// extracted by mini-css-extract-plugin
export default {"sortTrigger":"GuideReviews_sortTrigger__EWi-T","searchInput":"GuideReviews_searchInput__ZAuZj"};